import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store';
import closeImg from '../../../assets/images/close.svg';
import { useTranslation } from 'react-i18next';
import StringInput from '../../common/inputs/string-input';

const DelegationInformation = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'DELEGATION_INFORMATION' });
  const { t: tError } = useTranslation('', { keyPrefix: 'DELEGATION_INFORMATION.ERRORS' });
  const { delegationInformationStore: store } = useStore();
  const { delegates } = store;
  const handleChange = (index: number, field: keyof (typeof store.delegates)[0], value: string) => {
    store.updateDelegate(index, field, value);
  };

  const handleDelete = (index: number) => {
    store.removeDelegate(index);
  };

  return (
    <div className={'step'}>
      <h2>{t('TITLE')}</h2>
      <span className={'step-info'}>{t('INFO')}</span>

      <div>
        <table id={'delegateGrid'}>
          <tbody>
            {delegates.map((delegate, index) => (
              <tr key={delegate.uiKey}>
                <td>
                  <StringInput
                    value={delegate.fullName}
                    label={t('FULL_NAME')}
                    name={'fullName'}
                    onUpdate={value => handleChange(index, 'fullName', value)}
                    error={''}
                  />
                </td>
                <td>
                  <StringInput
                    value={delegate.email}
                    label={t('EMAIL')}
                    name={'email'}
                    onUpdate={value => handleChange(index, 'email', value)}
                    error={delegate.email.errorType ? tError(`${delegate.email.errorType.toUpperCase()}_EMAIL`) : ''}
                  />
                </td>
                <td>
                  <button className={'remove-delegate-btn'} onClick={() => handleDelete(index)}>
                    <img src={closeImg} alt="" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <button className={'n2pc-btn-text contact-add-btn delegate-add-btn'} onClick={() => store.addDelegate()}>
          {t('ADD_DELEGATE')}
        </button>
      </div>

      <span className={'step-info-small dark'}>{t('YOU_UNDERSTAND_AND_AGREE')}</span>
    </div>
  );
});

export default DelegationInformation;
